var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"px-0",attrs:{"text":""},on:{"click":_vm.back}},[_c('v-icon',[_vm._v("mdi mdi-arrow-left")]),_c('span',[_vm._v("Voltar")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }